import { Injectable } from '@angular/core';

import { EventBus } from '../event-bus';
import { ZoomCameraService } from './zoom-camera.service';
import { CameraService } from './camera.service';
import { MoveCameraService } from '../Component(2D and 3D)/2D/move-camera.service';
import { DrawCustomRoomService } from '../Component(2D and 3D)/2D/draw-custom-room.service';
import { Cut45AngleService } from './cut45-angle.service';
import { ZoomingDistanceService } from './zooming-distance.service';
import { CutCornerNotchService } from './cut-corner-notch.service';
import { MoveCornerService } from '../Component(2D and 3D)/2D/move-corner.service';
import { DragFloorEdge } from './drag-floor-edge.service';
import { RemovePointService } from './remove-point.service';
import { CutUshapeService } from './cut-ushape.service';
import { EditShapeComponent } from '../edit-shape/edit-shape.component';
import { AddStairsComponent } from '../add-stairs/add-stairs.component';
import { RemoveStairsService } from './remove-stairs.service';
import { AddTiersComponent } from '../add-tiers/add-tiers.component';
import { BuildTierService } from './build-tier.service';
import { RemoveTierService } from './remove-tier.service';
import { BuildWallService } from './build-wall.service';
import { RemoveWallService } from './remove-wall.service';
import { AddWallsComponent } from '../add-walls/add-walls.component';
import { Select3dService } from './select-3d.service';
import { DragWallEdgesService } from './drag-wall-edges.service';
import { MoveStairsService } from './move-stairs.service';
import { ObjectAddService } from '../Component(2D and 3D)/3D/ObjectAdd/object-add.service';
import { AccessoryControlsService } from '../Component(2D and 3D)/3D/ObjectControls/accessory-controls.service';
import { TierStepWidthService } from './tier-step-width.service';
import { Drag3D } from '../Component(2D and 3D)/3D/Drag/drag3-d.service';
import { OrbitService } from './orbit.service';
import { WindowDoorResizeComponent } from '../Component(2D and 3D)/Shared/ObjectResize/WindowDoorResizeComponent';
import { DeselectByEscComponent } from '../Component(2D and 3D)/Shared/DeselectByEscComponent';
import { DeleteObjectByDelKeyComponent } from '../Component(2D and 3D)/Shared/DeleteObjectByDelKeyComponent';
import { GenerateStairsService } from './generate-stairs.service';
import { RootComponent } from './proTools/components/RootComponent';
import { RemoveWindowsDoorsService } from './remove-windows-doors.service';
import { StairsDimensionsComponent } from '../Component(2D and 3D)/3D/stairs-dimensions.component';
import { ShadowCasterController } from './shadow-caster-controller.service';
import { ImageUtilsService } from './image-utils.service';
import { AwningControlsService } from '../Component(2D and 3D)/3D/ObjectControls/awning-controls.service';
import { RailLengthModifierService } from './rail-length-modifier.service';
import { DockRailAnchorService } from './dock-rail-anchor.service';
import { DockModeService } from './dock-mode.service';
import { DataForDisplayingMenuItemsService } from './data-for-displaying-menu-items.service';

@Injectable()
export class EngineService {
  constructor(
    private editShape: EditShapeComponent,
    private addStairs: AddStairsComponent,
    private addTiers: AddTiersComponent,
    private addWallsComponent: AddWallsComponent,
    private cameraManager: CameraService,
    private zoomIn2DComponent: ZoomCameraService,
    private moveCamera: MoveCameraService,
    private drawCustomRoom: DrawCustomRoomService,
    private cut45Angle: Cut45AngleService,
    private zoomIn3DComponent: ZoomingDistanceService,
    private cutCornerNotch: CutCornerNotchService,
    private moveCorner: MoveCornerService,
    private moveWall: DragFloorEdge,
    private removePoint: RemovePointService,
    private cutUshape: CutUshapeService,
    private generateStairs: GenerateStairsService,
    private removeStairsService: RemoveStairsService,
    private buildTierService: BuildTierService,
    private removeTierService: RemoveTierService,
    private buildWallService: BuildWallService,
    private removeWallService: RemoveWallService,
    private select3dService: Select3dService,
    private dragWallEdgesService: DragWallEdgesService,
    private moveStairsService: MoveStairsService,
    private objectAddService: ObjectAddService,
    private accessoryControlsService: AccessoryControlsService,
    private awningControlsService: AwningControlsService,
    private tierStepWidthService: TierStepWidthService,
    private drag3DComponent: Drag3D,
    private orbitControls: OrbitService,
    private windowDoorResizeComponent: WindowDoorResizeComponent,
    private deselectByEscComponent: DeselectByEscComponent,
    private deleteByDelKeyComponent: DeleteObjectByDelKeyComponent,
    private proToolsComponent: RootComponent,
    private removeWindowsDoorsService: RemoveWindowsDoorsService,
    private stairsDimensionsComponent: StairsDimensionsComponent,
    private shadowCaster: ShadowCasterController,
    private imageUtilsService: ImageUtilsService,
    private railLengthModifierService: RailLengthModifierService,
    private dockRailAnchorService: DockRailAnchorService,
    private dockModeService: DockModeService,
    private dataForDisplayingMenuItemsService: DataForDisplayingMenuItemsService
  ) {
    // opening a saved project of the other mode from the start screen flips
    // dock mode without going through changeStep/setStep — sync the dock-only
    // tools (anchors, rail-length arrows, suppressed edge-length labels) so
    // they never stay enabled on a deck and vice versa. Only these three are
    // touched: re-running the full setStep here would enable step components
    // while the floor may not exist yet (project open / fresh start)
    this.dockModeService.modeChanged.subscribe(isDock => {
      if (isDock && this.dataForDisplayingMenuItemsService.getCurrentStep() === 2) {
        this.railLengthModifierService.enable();
        this.dockRailAnchorService.enable();
        this.hideDimensionsForDockRailStep();
      } else {
        this.railLengthModifierService.disable();
        this.dockRailAnchorService.disable();
        this.restoreDimensionsAfterDockRailStep();
      }
    });
  }

  engine: EventBus;
  eng;
  in2D;
  tourStep: number;
  // edge-length labels hidden by the DockRail railing step (restored on leave)
  private dimensionsHiddenForDock = false;

  // Suppress the edge-length labels the same way the top-toolbar dimensions
  // toggle does: flip the shared isShowDimensions flag and remove the sprites.
  // Every consumer (toolbar icon, tier-selection redraw guards, drawTextSprites
  // itself) reacts to that flag, so nothing needs to be force-disabled.
  private hideDimensionsForDockRailStep() {
    if (!this.dimensionsHiddenForDock && this.imageUtilsService.isShowDimensionsValue) {
      this.dimensionsHiddenForDock = true;
      this.imageUtilsService.hideSprites();
    }
  }

  private restoreDimensionsAfterDockRailStep() {
    if (this.dimensionsHiddenForDock) {
      this.dimensionsHiddenForDock = false;
      this.imageUtilsService.isShowDimensionsSubject.next(true);
      this.imageUtilsService.showSprites();
    }
  }

  get() {
    if (!this.engine) {
      this.engine = new EventBus();

      this.engine.addComponents([
        this.proToolsComponent,
        this.editShape,

        this.cut45Angle,
        this.removePoint,
        this.cutUshape,
        this.moveCorner,
        this.moveWall,
        this.cutCornerNotch,

        this.addStairs,

        this.generateStairs,

        this.removeStairsService,

        this.addTiers,

        this.buildTierService,
        this.removeTierService,

        this.addWallsComponent,

        this.buildWallService,
        this.removeWallService,
        this.dragWallEdgesService,

        this.accessoryControlsService,
        this.awningControlsService,

        this.objectAddService,

        this.moveStairsService,

        // before select3d/moveCamera so an anchor click can stop the chain
        this.dockRailAnchorService,
        this.select3dService,
        this.stairsDimensionsComponent,
        this.windowDoorResizeComponent,
        this.drag3DComponent,
        this.zoomIn2DComponent,
        this.moveCamera,
        this.drawCustomRoom,
        this.zoomIn3DComponent,

        this.tierStepWidthService,
        this.railLengthModifierService,
        this.deselectByEscComponent,
        this.deleteByDelKeyComponent,
        this.proToolsComponent,
        this.removeWindowsDoorsService,
        this.shadowCaster,
        this.imageUtilsService
      ]);

      this.engine.init();

      for (let i = 0; i < this.engine.components.length; i++) {
        const comp = this.engine.components[i];
        comp.disable();
      }

      this.zoomIn2DComponent.enable();
      this.moveCamera.enable();
      this.select3dService.enable();
      this.accessoryControlsService.enable();
      this.awningControlsService.enable();
      this.drag3DComponent.enable();

      this.moveWall.enable();
      this.tierStepWidthService.enable();
      this.moveStairsService.enable();
      this.dragWallEdgesService.enable();
      this.windowDoorResizeComponent.enable();
      this.deselectByEscComponent.enable();
      this.deleteByDelKeyComponent.enable();
      this.imageUtilsService.enable();
    }
    this.setActiveStepState();
    return this.engine;
  }

  buildCustomRoom() {
    this.drawCustomRoom.enable();
  }

  closeCustomRoom() {
    this.drawCustomRoom.disable();
  }

  attachCanvas(canvas) {
    this.eng = this.get();
    this.eng.registerEvents(canvas);
    this.orbitControls.init(canvas);
  }

  enable() {
    this.engine.enable();
  }

  disable() {
    this.engine.disable();
  }

  setStep(step) {
    switch (step) {
      case 1:
        {
          this.proToolsComponent.disable();
          this.moveCamera.disable();

          this.moveWall.enable();
          this.tierStepWidthService.enable();
          this.moveStairsService.enable();
          this.dragWallEdgesService.enable();
          this.select3dService.enable();
          this.deleteByDelKeyComponent.enable();
          this.railLengthModifierService.disable();
          this.dockRailAnchorService.disable();
          this.restoreDimensionsAfterDockRailStep();
        }
        break;
      case 2:
        {
          this.moveWall.disable();
          this.tierStepWidthService.disable();
          this.moveStairsService.disable();
          this.dragWallEdgesService.disable();
          this.proToolsComponent.disable();
          this.moveCamera.disable();

          this.select3dService.enable();
          this.deleteByDelKeyComponent.enable();
          // DockRail: side anchors and rail-length arrows are active on the
          // railing step; the edge-length labels are suppressed there so they
          // don't mix with the anchor/arrow icons
          if (this.dockModeService.isDockMode()) {
            this.railLengthModifierService.enable();
            this.dockRailAnchorService.enable();
            this.hideDimensionsForDockRailStep();
          } else {
            this.railLengthModifierService.disable();
            this.dockRailAnchorService.disable();
            this.restoreDimensionsAfterDockRailStep();
          }
        }
        break;
      case 3:
        {
          this.moveWall.disable();
          this.railLengthModifierService.disable();
          this.dockRailAnchorService.disable();
          this.restoreDimensionsAfterDockRailStep();
          this.tierStepWidthService.disable();
          this.moveStairsService.disable();
          this.dragWallEdgesService.disable();
          this.select3dService.disable();
          this.deleteByDelKeyComponent.disable();
          this.generateStairs.disable();
          this.buildTierService.disable();
          this.buildWallService.disable();
          this.removeWindowsDoorsService.disable();
          this.removeStairsService.disable();
          this.removeTierService.disable();
          this.removeWallService.disable();
          this.removePoint.disable();
          this.moveCorner.disable();
          this.cut45Angle.disable();
          this.cutCornerNotch.disable();
          this.cutUshape.disable();

          this.proToolsComponent.enable();
          this.moveCamera.enable();
        }
        break;
    }
  }

  setActiveStepState() {
    if (!this.engine) return;

    this.in2D = this.cameraManager.isIn2D();
    switch (this.in2D) {
      case true:
        {
          this.zoomIn2DComponent.enable();
          this.moveCamera.enable();
          this.zoomIn3DComponent.disable();
        }
        break;
      case false:
        {
          this.zoomIn2DComponent.disable();
          this.moveCamera.disable();
          this.zoomIn3DComponent.enable();
        }
        break;
    }
  }

  setActiveTabState(tab) {
    if (!this.engine) return;

    switch (tab) {
      case 'editShape':
        {
          this.disableComponents();
          this.editShape.enable();
        }
        break;
      case 'addTiers':
        {
          this.disableComponents();
          this.addTiers.enable();
        }
        break;
      case 'addStairs':
        {
          this.disableComponents();
          this.addStairs.enable();
        }
        break;
      case 'addWall':
        {
          this.disableComponents();
          this.addWallsComponent.enable();
        }
        break;
      case 'addDoorsWindows':
        {
          this.disableComponents();
          this.objectAddService.enable();
        }
        break;
      case 'addAwnings':
        {
          this.disableComponents();
          this.objectAddService.enable();
        }
        break;
      case 'addTrellis':
        {
          this.disableComponents();
          this.objectAddService.enable();
        }
        break;
      case 'addAccessories':
        {
          this.disableComponents();
          this.objectAddService.enable();
        }
        break;
      case 'addGates':
      {
        this.disableComponents();
        this.objectAddService.enable();
      }
        break;
      default: {
        // setScenery, setHeight, editDeck
        this.disableComponents();
      }
    }
  }

  private disableComponents() {
    this.editShape.disable();

    this.addStairs.disable();

    this.addTiers.disable();

    this.addWallsComponent.disable();
  }

  dispose() {
    if (this.engine) {
      this.engine.dispose();
      this.engine = null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/services/engine.service.ts